import React from 'react';
import { Bets } from '@alien-platform/bo-core';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function PlayerDetailsTable({ betData }: { betData: Bets }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Operator',
      },
      value: {
        text: `${betData?.parentOpTitle ? betData?.parentOpTitle : betData?.opTitle}`,
      },
    },
    {
      label: {
        text: 'Brand',
      },
      value: {
        text: `${betData.parentOpId ? betData.opTitle : '-'}`,
      },
    },
    {
      label: {
        text: 'Player',
      },
      value: {
        text: betData?.playerBefore.username,
      },
    },
    {
      label: {
        text: 'Affiliate',
      },
      value: {
        text: betData?.playerBefore?.affId,
      },
    },
    {
      label: {
        text: 'Account Holder Name',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Bank Name',
      },
      value: {
        text: ``,
      },
    },
  ];

  return <HorizontalTable header="Player Details" tableData={tableData} />;
}
